import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
	},
};
